import api from './AxiosInstance';

export class PrestationsService {
  getPresta = async (codeprest) => {
    try {
      const response = await api.get(`/Actes/list/${codeprest}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };
  getAllPrestation = async () => {
    try {
      const response = await api.get(`/Prestations/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };
  // /Actes/list/{codeprest}

  AddLignePrestation = async (newPrestation) => {
    try {


      const response = await api.post(`/LignePrestations/add `, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  AddLigneDocMedoc = async (docData) => {
    try {


      const response = await api.post(`/Document/add/docManuel `, docData)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updateLigneDocMedoc = async (payload) => {
    try {


      const response = await api.put(`/Document/IPM/updateBefore`, payload)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  Verify = async (numdoc) => {
    try {


      const response = await api.get(`/Document/FindDocById?numdoc=${numdoc}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  addPrestation = async (newPrestation) => {
    try {


      const response = await api.post(`/Prestations/add`, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  addTauxPC = async (newPrestation) => {
    try {


      const response = await api.post(`/LignePrestations/TauxPC`, newPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updatePrestation = async (updatedPrestation) => {
    try {


      const response = await api.put(`/Prestations/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deletePrestation = async (prestationId) => {
    try {

      const response = await api.delete(`/Prestations/delete/${prestationId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };

  //pour lettre d'hospitalisation : 
  getLignePrestations = async (numfournPrefix) => {
    try {
      const response = await api.get(`/LignePrestations/Actes/list/${numfournPrefix}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };


  getLignePrestation04 = async () => {
    try {
      const response = await api.get(`/LignePrestations/Actes/list/04`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };
}


